module.exports = __webpack_public_path__ + "static/img/hello.763f4f6a.png";